import { ErrorsTranslate } from './errorsTranslate.model';

const errorsTranslateEN: ErrorsTranslate = {
  internalServerError: 'Server error. Please try again later',
  badRequest: 'Invalid request. Please check the data',
  notImplemented: 'Feature not available',
  resourceNotFound: 'Resource not found',
  unauthorizedAccess: 'Unauthorized access. Please log in',
  forbiddenAccess: 'Action not allowed',
  domainValidation: 'Invalid data. Please check and try again',
  invalidBodyRequest: 'Malformed request',
  invalidCredentials: 'Invalid email or password',
  userNotFound: 'User not found',
  userAlreadyExists: 'Email already registered',
  tenantNotFound: 'Organization not found',
  tenantAlreadyExists: 'Organization already registered',
  tenantIsInactive: 'Organization inactive',
  awsCognitoCodeMismatch: 'Incorrect verification code',
  awsCognitoExpiredCode: 'Verification code expired',
  awsCognitoInvalidParameter: 'Invalid request parameter',
  awsCognitoInvalidPassword: 'Invalid password',
  awsCognitoUserNotConfirmed: 'User not confirmed. Please check your email',
  awsCognitoLimitExceeded: 'Too many requests. Please try again later',
  leadNotFound: 'Lead not found',
  leadAlreadyExists: 'Lead already exists',
  membershipNotFound: 'Membership not found',
  userInactive: 'User inactive',
  userNotCreated: 'User could not be created. Please try again',
  cannotResetAdminPassword:
    'Cannot reset the password of another administrator',
  subscriptionNotFound: 'No subscription found for this organization',
  planNotFound: 'Plan not found',
  quotaExceeded: 'Plan limit reached. Upgrade to create more.',
  subscriptionNoCancelScheduled:
    'There is no scheduled cancellation to revert on this subscription.',
  subscriptionNoBillingCycle:
    'This subscription has no active billing cycle to apply the operation.',
  tenantDocumentRequired:
    'You must register a CPF or CNPJ before subscribing to a paid plan.',
  cannotRemoveOwner:
    "You can't remove the studio owner. Transfer ownership first.",
  cannotRemoveSelf: "You can't remove yourself from the team.",
  cannotChangeOwnerRole: "You can't change the role of the studio owner.",
  ownershipTargetMustBeAdministrator:
    'The new owner must already be an administrator in the studio.',
  cannotChangeSelfRole: "You can't change your own role.",
  invitationEmailMismatch:
    'This invitation was sent to a different email. Please log in with the invited account.',
  invitationNotFound: 'Invitation not found.',
  invitationExpired:
    'This invitation has expired. Ask the studio to send a new one.',
  invitationCanceled: 'This invitation was canceled.',
  invitationAlreadyAccepted: 'This invitation has already been accepted.',
  userAlreadyMember: 'This person is already a member of this studio team.',
  contractTemplateNotFound: 'Contract template not found',
  contractTemplateNotTagged:
    'Tag at least one variable in the document before saving the template',
  contractTemplateInvalidFile:
    'Invalid template file. Only .docx files are allowed',
  contractAnalysisFailed:
    'Could not analyze the contract template. Please try again',
  contractNotFound: 'Contract not found',
  contractMissingVariables: 'Required contract variables are missing',
  contractRenderFailed:
    'Could not generate the contract document. Please try again',
  contractInvalidStatusTransition: 'Invalid contract status change',
  contractSignedFileTooLarge:
    'The signed contract file exceeds the maximum allowed size',
  contractorNotFound: 'Contractor not found',
  leadLegalInfoNotFound: 'Client contract data not found',
  clientPortalAccessDenied:
    'We could not open the portal. Check the link and the ID number',
  clientPortalDocumentRequired:
    'Fill in the client ID number under the Contracts tab to enable the portal',
  global: 'Unexpected error. Please try again later',
  boundary: {
    title: 'Something went wrong',
    description:
      'We hit an unexpected error. Try reloading the page or go back to the home screen.',
    retry: 'Try again',
    home: 'Back to home',
  },
};

export default errorsTranslateEN;
